import {  Outlet } from 'react-router-dom';
// @mui
import {Stack } from '@mui/material';

import MainFooter from './MainFooter';
import MainHeader from './MainHeader';

// ----------------------------------------------------------------------

export default function MainLayout() {


  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainHeader />
      <Outlet />
      <MainFooter />
    </Stack>
  );
}
